import { ListValue } from './list-value.model';

export interface BooleanValue extends Omit<ListValue, 'canBeDeleted'> {
  canBeDeleted?: boolean;
}
